export default "__VITE_ASSET__BDo$Pew1__"